import { useState } from 'react';
import firebase from 'gatsby-plugin-firebase';
import useAsyncEffect from 'hooks/useAsyncEffect';
import { isProduction } from 'utils/env';

export const usePostViewCount = (slug: string) => {
  const [viewCount, setViewCount] = useState<number | undefined>(undefined);

  const increaseView = async (): Promise<number> => {
    const database = firebase.database().ref('views').child(slug);
    if (isProduction === false) {
      return (await database.once('value')).val();
    }

    try {
      await database.transaction(currentValue => (currentValue ?? 0) + 1);
      return (await database.once('value')).val();
    } catch {
      return 0;
    }
  };

  useAsyncEffect(async () => {
    try {
      const snapshot = await increaseView();
      setViewCount(snapshot);
    } catch {
      setViewCount(0);
    }
  }, []);

  return viewCount;
};
